export class IncorrectCriteriaError extends Error {
  readonly _tag = 'IncorrectCriteriaError'
}

export type UseCriteriaHookApi<T> = {
  value: T
  apply: (value: T) => void
}
